import { useState } from "react";
import {
    Box, Divider, Drawer, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, TextField, FormControlLabel, Checkbox, Button, Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NoteAltIcon from '@mui/icons-material/NoteAlt'; // Icono para Nota de Crédito
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'; // Icono para Guía de Ingreso
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'; // Icono para Ver Detalle
import { useTicketStore } from "../../../../hooks/useTicketStore";

interface Props {
    drawerOpenRuta: boolean;
    handleCloseDrawer: () => void;
    dispatchGuides: any[];
    handleWarehouseAction: (id: number) => void;
}

const facturasIncidencia = [
    {
        folio: 1,
        conductor: "Luis",
        patente: "GHJ-67H",
        sector: "General",
        fecha: "2025-02-17",
        productos: [
            {
                id: 101,
                cantidadTotal: 10,
                producto: "KG. PAPAS",
                pedidos: [
                    { id: "A-1", cantidad: 2 },
                    { id: "A-2", cantidad: 3 },
                    { id: "A-3", cantidad: 1 },
                    { id: "A-4", cantidad: 4 }
                ]
            },
            {
                id: 102,
                cantidadTotal: 5,
                producto: "KG. TOMATES",
                pedidos: [
                    { id: "B-1", cantidad: 2 },
                    { id: "B-2", cantidad: 3 }
                ]
            }
        ]
    },
    {
        folio: 2,
        conductor: "María",
        patente: "XYZ-123",
        sector: "Centro",
        fecha: "2025-02-18",
        productos: [
            {
                id: 103,
                cantidadTotal: 8,
                producto: "KG. CEBOLLAS",
                pedidos: [
                    { id: "C-1", cantidad: 3 },
                    { id: "C-2", cantidad: 5 }
                ]
            },
            {
                id: 104,
                cantidadTotal: 12,
                producto: "KG. ZANAHORIAS",
                pedidos: [
                    { id: "D-1", cantidad: 4 },
                    { id: "D-2", cantidad: 4 },
                    { id: "D-3", cantidad: 4 }
                ]
            }
        ]
    },
    {
        folio: 3,
        conductor: "Carlos",
        patente: "LMN-789",
        sector: "Sur",
        fecha: "2025-02-19",
        productos: [
            {
                id: 105,
                cantidadTotal: 6,
                producto: "LITROS DE LECHE",
                pedidos: [
                    { id: "E-1", cantidad: 2 },
                    { id: "E-2", cantidad: 2 },
                    { id: "E-3", cantidad: 2 }
                ]
            },
            {
                id: 106,
                cantidadTotal: 20,
                producto: "KG. HARINA",
                pedidos: [
                    { id: "F-1", cantidad: 5 },
                    { id: "F-2", cantidad: 5 },
                    { id: "F-3", cantidad: 5 },
                    { id: "F-4", cantidad: 5 }
                ]
            }
        ]
    },
    {
        folio: 4,
        conductor: "Ana",
        patente: "QRS-456",
        sector: "Norte",
        fecha: "2025-02-20",
        productos: [
            {
                id: 107,
                cantidadTotal: 15,
                producto: "KG. AZÚCAR",
                pedidos: [
                    { id: "G-1", cantidad: 5 },
                    { id: "G-2", cantidad: 5 },
                    { id: "G-3", cantidad: 5 }
                ]
            },
            {
                id: 108,
                cantidadTotal: 10,
                producto: "KG. SAL",
                pedidos: [
                    { id: "H-1", cantidad: 4 },
                    { id: "H-2", cantidad: 3 },
                    { id: "H-3", cantidad: 3 }
                ]
            }
        ]
    },
    {
        folio: 5,
        conductor: "Jorge",
        patente: "TUV-555",
        sector: "Oeste",
        fecha: "2025-02-21",
        productos: [
            {
                id: 109,
                cantidadTotal: 25,
                producto: "KG. POLLO",
                pedidos: [
                    { id: "I-1", cantidad: 10 },
                    { id: "I-2", cantidad: 8 },
                    { id: "I-3", cantidad: 7 }
                ]
            },
            {
                id: 110,
                cantidadTotal: 18,
                producto: "KG. CARNE DE RES",
                pedidos: [
                    { id: "J-1", cantidad: 6 },
                    { id: "J-2", cantidad: 6 },
                    { id: "J-3", cantidad: 6 }
                ]
            }
        ]
    }
];

const facturasIncidenciaLList = [
    {
        folio: 1001,
        productos: [
            { id: 1, producto: "KG. PAPAS", cantidadTotal: 10, incidencia: 3 },
            { id: 2, producto: "KG. TOMATES", cantidadTotal: 5, incidencia: 1 }
        ]
    },
    {
        folio: 1002,
        productos: [
            { id: 3, producto: "KG. CEBOLLAS", cantidadTotal: 8, incidencia: 2 },
            { id: 4, producto: "KG. ZANAHORIAS", cantidadTotal: 12, incidencia: 0 }
        ]
    },
    {
        folio: 1003,
        productos: [
            { id: 5, producto: "LITROS DE LECHE", cantidadTotal: 6, incidencia: 1 },
            { id: 6, producto: "KG. HARINA", cantidadTotal: 20, incidencia: 5 }
        ]
    }
];


export const DrawerDispatchGuides: React.FC<Props> = (props) => {
    const { drawerOpenRuta, handleCloseDrawer, dispatchGuides, handleWarehouseAction } = props;
    const { routeSelected} = useTicketStore();

    const [entregados, setEntregados] = useState<number[]>([]);
    const [incidenciaDrawerOpen, setIncidenciaDrawerOpen] = useState(false);
    const [incidencias, setIncidencias] = useState<{ [key: number]: any }>({});
    const [observaciones, setObservaciones] = useState<string>("");
    const [pedidosAfectados, setPedidosAfectados] = useState<{ [key: string]: number }>({});

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerType, setDrawerType] = useState<"detalle" | "notaParcial" | "notaTotal" | "guiaIngreso" | null>(null);
    const [selectedFactura, setSelectedFactura] = useState<any | null>(null);
    const [selectedFacturaList, setSelectedFacturaList] = useState<any | null>(null);

    const abrirDrawerIncidencia = (factura: any) => {
        setSelectedFactura(factura);
        setIncidenciaDrawerOpen(true);
    };

    const cerrarDrawerIncidencia = () => {
        setIncidenciaDrawerOpen(false);
        setSelectedFactura(null);
        setPedidosAfectados({});
        setObservaciones("");
    };

    const marcarComoEntregado = (id: number) => {
        setEntregados([...entregados, id]);
    };

    const manejarCambioCantidad = (pedidoId: string, cantidad: number) => {
        setPedidosAfectados({ ...pedidosAfectados, [pedidoId]: cantidad });
    };

    const registrarIncidencia = () => {
        if (selectedFactura) {
            setIncidencias({
                ...incidencias,
                [selectedFactura.folio]: {
                    observaciones,
                    productosAfectados: selectedFactura.productos.map((p: any) => ({
                        ...p,
                        pedidos: p.pedidos.map((pedido: any) => ({
                            ...pedido,
                            cantidadAfectada: pedidosAfectados[pedido.id] || 0
                        }))
                    }))
                }
            });
        }
        cerrarDrawerIncidencia();
    };

    const abrirDrawer = (tipo: "detalle" | "notaParcial" | "notaTotal" | "guiaIngreso", factura: any) => {
        setDrawerType(tipo);
        setSelectedFacturaList(factura);
        setDrawerOpen(true);
    };

    const cerrarDrawer = () => {
        setDrawerOpen(false);
        setDrawerType(null);
        setSelectedFacturaList(null);
    };

    return (
        <>
            <Drawer
                anchor="right"
                open={drawerOpenRuta}
                onClose={handleCloseDrawer}
                PaperProps={{ sx: { width: 550, backgroundColor: "#f9f9f9", boxShadow: 2 } }}
            >
                <Box sx={{ p: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        Detalles de la Ruta: {routeSelected?.n_route}
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {/* Tabla de bodegas */}
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Bodega</TableCell>
                                    <TableCell>Acción</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {Array.from(
                                    new Map(
                                        dispatchGuides
                                            .filter((guide) => guide.warehouse?.id)
                                            .map((guide) => [guide.warehouse.id, { id: guide.warehouse.id, name: guide.warehouse.name }])
                                    ).values()
                                ).map((warehouse) => (
                                    <TableRow key={warehouse.id} sx={{ backgroundColor: entregados.includes(warehouse.id) ? "#d4edda" : "inherit" }}>
                                        <TableCell>{warehouse?.name}</TableCell>
                                        <TableCell>
                                            <Tooltip title="Ver guía de despacho">
                                                <IconButton size="small" color="inherit" onClick={() => handleWarehouseAction(warehouse.id)}>
                                                    <VisibilityIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            {/* <Tooltip title="Marcar como entregado">
                                                <IconButton size="small" color="success" onClick={() => marcarComoEntregado(warehouse.id)}>
                                                    <CheckIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Registrar incidencia">
                                                <IconButton size="small" color="error" onClick={() => abrirDrawerIncidencia(facturasIncidencia[0])}>
                                                    <ErrorIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip> */}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    {/* <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
                        Facturas con Incidencias:
                    </Typography>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Folio</TableCell>
                                    <TableCell>Detalle</TableCell>
                                    <TableCell>Acción</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {facturasIncidenciaLList.map((factura) => (
                                    <TableRow key={factura.folio}>
                                        <TableCell>{factura.folio}</TableCell>
                                        <TableCell>
                                            {factura.productos.map((producto) => (
                                                <Typography
                                                    key={producto.id}
                                                    sx={{ color: producto.incidencia > 0 ? "red" : "inherit" }}
                                                >
                                                    {producto.producto}: {producto.cantidadTotal}
                                                    {producto.incidencia > 0 && ` (Incidencia: ${producto.incidencia})`}
                                                </Typography>
                                            ))}
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title="Ver Detalle">
                                                <IconButton size="small" color="inherit" onClick={() => abrirDrawer("detalle", factura)}>
                                                    <RemoveRedEyeIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Generar Nota de Crédito Parcial">
                                                <IconButton size="small" color="warning" onClick={() => abrirDrawer("notaParcial", factura)}>
                                                    <NoteAltIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Generar Nota de Crédito Total">
                                                <IconButton size="small" color="error" onClick={() => abrirDrawer("notaTotal", factura)}>
                                                    <NoteAltIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Generar Guía de Ingreso">
                                                <IconButton size="small" color="success" onClick={() => abrirDrawer("guiaIngreso", factura)}>
                                                    <AssignmentTurnedInIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer> */}


                    {/* Drawer con detalles */}
                    <Drawer anchor="right" open={drawerOpen} onClose={cerrarDrawer} PaperProps={{ sx: { width: 500 } }}>
                        {/* Drawer con detalles */}
                        <Drawer anchor="right" open={drawerOpen} onClose={cerrarDrawer} PaperProps={{ sx: { width: 500 } }}>
                            {selectedFacturaList && (
                                <Box sx={{ p: 3 }}>
                                    <Typography variant="h6" gutterBottom>
                                        {drawerType === "detalle" && `Detalle de Factura N° ${selectedFacturaList.folio}`}
                                        {drawerType === "notaParcial" && `Nota de Crédito Parcial - Factura N° ${selectedFacturaList.folio}`}
                                        {drawerType === "notaTotal" && `Nota de Crédito Total - Factura N° ${selectedFacturaList.folio}`}
                                        {drawerType === "guiaIngreso" && `Guía de Ingreso - Factura N° ${selectedFacturaList.folio}`}
                                    </Typography>
                                    <Divider sx={{ my: 2 }} />

                                    {/* Tabla de productos */}
                                    <TableContainer sx={{ maxHeight: 300 }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Producto</TableCell>
                                                    <TableCell>Cantidad</TableCell>
                                                    <TableCell>Incidencia</TableCell>
                                                    <TableCell>Precio</TableCell>
                                                    <TableCell>Subtotal</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectedFacturaList.productos.map((producto: any) => {
                                                    const precioUnitario = 10; // Precio ficticio
                                                    const subtotal = producto.cantidadTotal * precioUnitario;
                                                    return (
                                                        <TableRow key={producto.id}>
                                                            <TableCell>{producto.producto}</TableCell>
                                                            <TableCell>{producto.cantidadTotal}</TableCell>
                                                            <TableCell sx={{ color: producto.incidencia > 0 ? "red" : "inherit" }}>
                                                                {drawerType === "notaParcial" || drawerType === "guiaIngreso" ? (
                                                                    <TextField
                                                                        type="number"
                                                                        variant="standard"
                                                                        size="small"
                                                                        sx={{ width: 50 }}
                                                                        defaultValue={producto.incidencia}
                                                                    />
                                                                ) : (
                                                                    producto.incidencia
                                                                )}
                                                            </TableCell>
                                                            <TableCell>S/. {precioUnitario.toFixed(2)}</TableCell>
                                                            <TableCell>S/. {subtotal.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {/* Cálculo de Totales */}
                                    <Box sx={{ mt: 2, textAlign: "right", pr: 2 }}>
                                        <Typography variant="body1" sx={{ display: "flex", justifyContent: "space-between" }}>
                                            <span>Subtotal:</span>
                                            <strong>S/. {selectedFacturaList.productos.reduce((acc: number, p: any) => acc + p.cantidadTotal * 10, 0).toFixed(2)}</strong>
                                        </Typography>
                                        <Typography variant="body1" sx={{ display: "flex", justifyContent: "space-between" }}>
                                            <span>IVA (18%):</span>
                                            <strong>S/. {(selectedFacturaList.productos.reduce((acc: number, p: any) => acc + p.cantidadTotal * 10, 0) * 0.18).toFixed(2)}</strong>
                                        </Typography>
                                        <Typography variant="h6" sx={{ display: "flex", justifyContent: "space-between" }}>
                                            <span>Total:</span>
                                            <strong>S/. {(selectedFacturaList.productos.reduce((acc: number, p: any) => acc + p.cantidadTotal * 10, 0) * 1.18).toFixed(2)}</strong>
                                        </Typography>
                                    </Box>

                                    {/* Botón de acción según el tipo de Drawer */}
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color={drawerType === "detalle" ? "primary" :
                                            drawerType === "notaParcial" ? "warning" :
                                                drawerType === "notaTotal" ? "error" :
                                                    "success"}
                                        sx={{ mt: 2 }}
                                        onClick={() => {
                                            console.log(`Ejecutando acción para ${drawerType} en factura ${selectedFacturaList.folio}`);
                                            cerrarDrawer();
                                        }}
                                    >
                                        {drawerType === "detalle" && "Cerrar Detalle"}
                                        {drawerType === "notaParcial" && "Generar Nota de Crédito Parcial"}
                                        {drawerType === "notaTotal" && "Generar Nota de Crédito Total"}
                                        {drawerType === "guiaIngreso" && "Generar Guía de Ingreso"}
                                    </Button>
                                </Box>
                            )}
                        </Drawer>


                    </Drawer>

                </Box>
            </Drawer>

            {/* Drawer para registrar incidencias */}
            <Drawer
                anchor="right"
                open={incidenciaDrawerOpen}
                onClose={cerrarDrawerIncidencia}
                PaperProps={{ sx: { width: 500, backgroundColor: "#fff", boxShadow: 2 } }}
            >
                {selectedFactura && (
                    <Box sx={{ p: 3 }}>
                        <Typography variant="h6" gutterBottom>
                            Registrar Incidencia - Reparto N° {selectedFactura.folio}
                        </Typography>
                        <Divider sx={{ my: 2 }} />

                        {/* Información del reparto */}
                        {selectedFactura.productos.map((producto: any) => (
                            <Accordion key={producto.id}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="body1"><strong>{producto.producto}</strong> - Total: {producto.cantidadTotal}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {producto.pedidos.map((pedido: any) => (
                                        <Box key={pedido.id} sx={{ display: "flex", alignItems: "center", my: 1 }}>
                                            <Typography sx={{ flexGrow: 1 }}>Pedido {pedido.id}: {pedido.cantidad} unidades</Typography>
                                            <TextField
                                                label="Afectadas"
                                                type="number"
                                                size="small"
                                                sx={{ width: 100 }}
                                                value={pedidosAfectados[pedido.id] || ""}
                                                onChange={(e) => manejarCambioCantidad(pedido.id, parseInt(e.target.value) || 0)}
                                            />
                                        </Box>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        ))}
                        <Button fullWidth variant="contained" sx={{ mt: 2 }} onClick={registrarIncidencia}>
                            Registrar Incidencia
                        </Button>
                    </Box>
                )}
            </Drawer>
        </>
    );
};
